export default {
  ARCHIVE: 'ARCHIVE',
  UNARCHIVE: 'UNARCHIVE',
  EDIT_TAGS: 'EDIT_TAGS',
  DELETE: 'DELETE'
};